
import { defineComponent } from "vue";
import { useImport } from "./useImport";
import OrderModal from "@/components/order-modal/Main.vue";
import AddressModeToggle from "@/components/address-mode-toggle/Main.vue";
import OrderCreateSuccessModal from "@/components/order-create-success-modal/Main.vue";

export default defineComponent({
  components: {
    AddressModeToggle,
    OrderModal,
    OrderCreateSuccessModal,
  },
  setup() {
    const {
      addressMode,
      tableRef,
      importOrders,
      addresses,
      address,
      checkImportOrderFile,
      selectedOrder,
      createOrders,
      loading,
      updateTabulator,
      createOrderTabulator,
      createAllOrderTabulator,
      deleteRowTabulator,
      successIds,
    } = useImport();

    return {
      addressMode,
      tableRef,
      importOrders,
      addresses,
      address,
      selectedOrder,
      checkImportOrderFile,
      createOrders,
      loading,
      updateTabulator,
      createOrderTabulator,
      createAllOrderTabulator,
      deleteRowTabulator,
      successIds,
    };
  },
  methods: {
    downloadSample() {
      window.open(`/filemaunew.xlsx`, `_blank`);
    },
    downloadArea() {
      // Danh mục J&T gồm cả 2 cấp mới, 3 cấp cũ và bảng mapping cũ sang mới
      if (this.addressMode === "new") {
        window.open(`/danh-muc-dia-chi-jt.xlsx`, `_blank`);
        return;
      }
      window.open(
        `https://vip.jtexpress.vn/yuenan-vip-interface/api/download?fileNames=areaInfo/AreaInformation.xls`,
        `_blank`
      );
    },
  },
});
